var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.66659H8.66683V11.9999C8.66683 12.3666 8.36683 12.6666 8.00016 12.6666C7.6335 12.6666 7.3335 12.3666 7.3335 11.9999V8.66659H4.00016C3.6335 8.66659 3.3335 8.36659 3.3335 7.99992C3.3335 7.63325 3.6335 7.33325 4.00016 7.33325H7.3335V3.99992C7.3335 3.63325 7.6335 3.33325 8.00016 3.33325C8.36683 3.33325 8.66683 3.63325 8.66683 3.99992V7.33325H12.0002C12.3668 7.33325 12.6668 7.63325 12.6668 7.99992C12.6668 8.36659 12.3668 8.66659 12.0002 8.66659Z",
    fill: "#008420"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlus);
export default __webpack_public_path__ + "static/media/green_plus.1e82c56422f4a877b6c52a09aba5e776.svg";
export { ForwardRef as ReactComponent };